import React from "react";
import { classnames } from "@culturehq/components";

const Control = ({ active, ariaLabel, className, children, disabled, onClick }) => {
  const ariaLabelId = `control-${ariaLabel?.replace(/ /g, "") || ""}`;
  return (
    <>
      <div id={ariaLabelId} style={{ display: "none" }}>{ariaLabel}</div>
      <button
        aria-labelledby={ariaLabelId}
        className={classnames("chq-edi--ct", className, { "chq-edi--ct-ac": active })}
        type="button"
        disabled={disabled}
        onClick={onClick}
      >
        {children}
      </button>
    </>
  );
};

export default Control;
